export default __webpack_public_path__ + "static/media/unit1.e92f6550.jpg";